import { Store } from 'redux';

export class ActionDispatcher {
  constructor(private store: Store) {}

  public dispatch(action: any): any {
    return this.store.dispatch(action);
  }
}
